// extracted by mini-css-extract-plugin
export default {"containerAdd":"MinhasLojas_containerAdd__vbzyM","iconAdd":"MinhasLojas_iconAdd__HVSRd"};